import React from 'react';
// import UserNav from './userNav';
// import UserConnect from './userConnect';

import { useEffect, useState } from 'react';
import { useSelector } from "react-redux"
import { cle_COURTJUS, URL_COURTJUS_BACK } from '../constants/sources.js';
import { NavLink } from "react-router-dom";

const Adherents = (props) => {

    const { userCJ } = useSelector(state => state);
    const [adherents, setAdherents] = useState([]);
    const [filtre, setFiltre] = useState([]);
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/users`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                setAdherents(res);
            });
    }, []);

    const handleChange = (event) => {
        event.preventDefault();
        const { value } = event.target;
        setFiltre(value);
        let url = ""
        value.length < 1 ? url = `${URL_COURTJUS_BACK}/users` : url = `${URL_COURTJUS_BACK}/usersfiltre/${value}`;
        fetch(url, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                setAdherents(res);
            });
    };

    function handleSubmit(event) {
        event.preventDefault();
    }

    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    }

    const filteredAdherents = adherents.filter(q => {
        if (filtre.length === 0) {
          return q.uActif !== 0;
        } else {
          // Ajoutez ici votre logique de filtrage supplémentaire si nécessaire
          return true; // Ou appliquez un autre filtre
        }
      });

    return (
        <main className="container">
            <div className="main-down"></div>
            {userCJ.uAdmin && <>
                <h3>Nos adherents</h3>
                <section className="nav-admin">
                    <form method="POST" id="formFiltre" className='form-filtre'>
                        <label htmlFor="filtre"><img src="img/search.png" alt="Rechercher" /></label>
                        <input type="text" name="filtre" id="filtre" value={filtre} onChange={handleChange} onSubmit={handleSubmit} onKeyDown={handleKeyDown} />
                    </form>
                </section>
                <div className="saut"></div>

                {filteredAdherents.map((q, i) => (
                    <section className={`section-prods ${q.uProducteur ? 'section-prods-producteur' : 'section-prods-user'}`} key={i}>
                    {/* <img src={`/img/pictures/${q.uPhotoProfil}`} alt="profil de l'utilisateur" className="float-prods" /> */}
                    <article className="section-prods-fiche">
                        <h3 className={`${q.uActif === 0 && 'section-prods-inactif'}`}>
                        {(userCJ.uAdmin || userCJ.uNum === q.uNum) && (
                            <NavLink
                            to={`/userficheup/${q.uNum}`}
                            aria-label="Modifier la fiche"
                            className="zone-tel-masque"
                            title="modifier la fiche"
                            >
                            <img
                                className="btn-articles"
                                src="/img/edit_R.png"
                                height={'24px'}
                                alt="Voir plus"
                            />
                            </NavLink>
                        )}
                        &nbsp;
                        {q.uPrenom} {q.uNom} 
                        </h3>
                        <p>Compte : {q.uMail} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{q.uActif === 0 && '[inactif]'}</p>
                        <p>{q.uTel}.</p>
                        <h4>{q.uStructure} </h4>
                        <p>{q.uMailPro && 'Mail-pro : '} {q.uMailPro && q.uMailPro}</p>
                        <p className="p-impact">{q.uProduction}</p>
                    </article>

                    {/* <article className="section-prods-infos">
                        <p>{q.uInfosComp}</p>
                    </article> */}
                    </section>
                ))}
                <section className="section-prods">
                    <img src={`/img/pictures/profil.png`} alt="profil d'un nouvel utilisateur" className="float-prods" />
                    <article className="section-prods-fiche section-demie">
                        <h2>&nbsp;</h2>
                        <p className="p-impact">&nbsp;</p>
                        <NavLink to={`/userfichecreat`} className="btn btn-primary" aria-label="Ajouter une fiche" title="Ajouter une fiche">Ajouter un utilisateur</NavLink>
                        <p>&nbsp;</p>
                    </article>
                </section>
            </>}
            {userCJ.uAdmin === false && <section className="section-prods"><p className="p-impact">Vous n'etes pas autorisé à acceder à ces informations</p></section>}
            <div className="main-down"></div>
        </main>

    )
}

export default Adherents;